module.exports = __webpack_public_path__ + "img/Landing_Page_step_01.a4c099be.jpg";